import { AddOutlined, EditOutlined, RefreshOutlined } from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useCallback, useEffect, useState } from "react";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import SearchIcon from "@mui/icons-material/Search";
import { AdministrateurService } from "../../../../service/admin_service/AdministrateurService";
import { useQuery } from "../../../../hooks/useQuery";
import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import useContextMenu from "../../../../hooks/useContextMenu";
import AdministrateursDialogForm from "./AdministrateursDialogForm";

const AdministrateursList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const [administrateurs, setAdministrateurs] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const { Toast, showToast } = useToast();
  const [admiFormOpen, setAdmiFormOpen] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [idAdmi, setIdAdmi] = useState(null);
  const [idsButtonLoading, setIdsButtonLoading] = useState([]);
  const { openMenu, MenuComponent } = useContextMenu([
    {
      icon: <EditOutlined />,
      label: "Modifier",
      color: "primary",
      action: (row) => handleOpenOpenAdminForm(row.id_ext_user),
    },
    {
      icon: <HistoryOutlinedIcon />,
      label: "Historique d'actions",
      color: "primary",
      disabled: true,
      action: (row) => handleRemoveRole(row),
    },
    {
      icon: <KeyOutlinedIcon />,
      label: "Reset mot de passe",
      color: "primary",
      disabled: true,
      action: (row) => handleRemoveRole(row),
    },
    {
      icon: <LockOutlinedIcon />,
      label: "Bloquer le compte",
      color: "primary",
      disabled: true,
      action: (row) => handleRemoveRole(row),
    },
    {
      icon: <DeleteOutlinedIcon />,
      label: "Supprimer ",
      color: "error",
      action: (row) => handleRemoveRole(row),
    },
  ]);

  const handleConfirmRemoveRole = (obj) => {
    AdministrateurService.remove_role(obj).then((res) => {
      if (res && res.data) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.data.message);
        handleFetchAdminList();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleRemoveRole = useCallback(
    (obj) => {
      openConfirmDialog(
        "Supprimer le role",
        "Etes-vous sur supprimer l'administrateur selectionné ?",
        () => {
          handleConfirmRemoveRole(obj);
        }
      );
    },
    [id_type]
  );
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const query = useQuery();
  const navigate = useNavigate();

  const handleConfirmAddAdministrator = () => {
    openConfirmDialog(
      "Ajouter un administrateur",
      "Vous pouvez ajouter un administrateur via la liste des utilisateurs PGI. Voulez-vous continuer ?",
      () => {
        query.set("tab", 1);
        navigate(`?${query.toString()}`);
      }
    );
  };

  const handleFetchAdminList = () => {
    setDataLoading(true);
    AdministrateurService.lister({})
      .then((res) => {
        if (res && res.data) {
          setAdministrateurs(res.data);
          setFilteredRows(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleOpenOpenAdminForm = (idAdmin) => {
    setIdAdmi(idAdmin);
    setAdmiFormOpen(true);
  };

  const handleCloseAmiForm = () => {
    setAdmiFormOpen(false);
    handleFetchAdminList();
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(administrateurs);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      administrateurs.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "full_name",
      headerName: "Nom et prénoms",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "email",
      headerName: "Adresse email",
      flex: 0.5,
      minWidth: 150,
    },
    /*  {
      field: "role",
      headerName: "Rôle",
      flex: 0.5,
      minWidth: 150,
    }, */
    {
      field: "created_at",
      headerName: "Date d'ajout",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "updated_at",
      headerName: "Dernière modification",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 100,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              // sx={{display:'none'}}
              loading={idsButtonLoading.includes(
                "excel_export" + params.row.id_type
              )}
              title="Exporter en excel les reponses aux formulaires sur l'offre selectionnées"
              color="primary"
              onClick={(e) => openMenu(e, params.row)}
            >
              <MoreVertOutlinedIcon />
            </IconButton>
            <MenuComponent />
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchAdminList();
  }, []);

  return (
    <>
      <AdministrateursDialogForm
        open={admiFormOpen}
        onFormClose={() => handleCloseAmiForm()}
        idUserAdmin={idAdmi}
      />
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Les administrateurs"
              action={
                <Grid container spacing={2} justifyContent="space-around">
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      placeholder="Recherche"
                      onChange={(e) => handleFilter(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      title="Actualiser"
                      color="primary"
                      onClick={handleFetchAdminList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      onClick={(e) => handleConfirmAddAdministrator()}
                      title="Ajouter nouveau administrateur"
                    >
                      <AddOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                // rows={offres}
                rows={filteredRows}
                getRowId={(row) => row.id_ext_user}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AdministrateursList;
